(function () {
    const DOTS_PER_GROUP = 8;
    const MOBILE_WIDTH = 768;
    const observedWrappers = new WeakSet();
    let rafId = null;

    function isMobile() {
      return window.innerWidth <= MOBILE_WIDTH;
    }

    function getSelectedIndex(dots) {
      for (let i = 0; i < dots.length; i++) {
        if (
          dots[i].classList.contains('is-selected') ||
          dots[i].getAttribute('aria-current') === 'step'
        ) {
          return i;
        }
      }

      return 0;
    }

    function updateDotsWrapper(dotWrapper) {
      if (!dotWrapper) return;

      const dots = dotWrapper.querySelectorAll('.dot');
      if (!dots.length) return;

      if (!isMobile()) {
        dots.forEach(function (dot) {
          dot.style.display = '';
        });
        return;
      }

      const selectedIndex = getSelectedIndex(dots);
      const groupStart = Math.floor(selectedIndex / DOTS_PER_GROUP) * DOTS_PER_GROUP;
      const groupEnd = groupStart + DOTS_PER_GROUP;

      dots.forEach(function (dot, index) {
        dot.style.display = index >= groupStart && index < groupEnd ? '' : 'none';
      });
    }

    function updateAllDots() {
      const dotWrappers = document.querySelectorAll(
        '.product-slideshow .flickity-page-dots'
      );

      dotWrappers.forEach(function (dotWrapper) {
        updateDotsWrapper(dotWrapper);

        if (observedWrappers.has(dotWrapper)) return;

        observedWrappers.add(dotWrapper);

        const observer = new MutationObserver(function () {
          updateDotsWrapper(dotWrapper);
        });

        observer.observe(dotWrapper, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'aria-current']
        });
      });
    }

    function requestUpdate() {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId = requestAnimationFrame(function () {
        updateAllDots();
        rafId = null;
      });
    }


    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAllDots);
    } else {
      updateAllDots();
    }

  
    window.addEventListener('load', updateAllDots);


    window.addEventListener('resize', requestUpdate);

    document.addEventListener('shopify:section:load', function () {
      requestUpdate();
    });


    const bodyObserver = new MutationObserver(function (mutations) {
      let shouldUpdate = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (
            node.matches?.('.product-slideshow .flickity-page-dots') ||
            node.querySelector?.('.product-slideshow .flickity-page-dots')
          ) {
            shouldUpdate = true;
          }
        });
      });

      if (shouldUpdate) {
        requestUpdate();
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();